export default __webpack_public_path__ + "static/runtask1-b40f5f7bd13353948fbfa7397cf48a6c.png";